import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { AiIcon } from '../atoms/icons/ai_icon';
import { AiCheckIcon } from '../atoms/icons/ai_check_icon';
export const GoalMatchingAssessmentResultReady = ({ userName, isLoading, classObject }) => {
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement("div", { className: css(styles.iconBox) },
            React.createElement("div", { className: css(isLoading && styles.animation) }, isLoading ? React.createElement(AiIcon, { classObject: styles.aiIcon }) : React.createElement(AiCheckIcon, { classObject: styles.aiIcon }))),
        React.createElement("div", { className: css(styles.loadingMessage) }, isLoading ? (React.createElement(React.Fragment, null,
            "\u30CA\u30A4\u30B9\u30C1\u30E7\u30A4\u30B9\uFF01\uD83C\uDF1F",
            React.createElement("br", null),
            userName,
            "\u3055\u3093\u306E\u305F\u3081\u306E\u30E1\u30CB\u30E5\u30FC\u3092\u6E96\u5099\u4E2D\u3067\u3059...")) : (React.createElement(React.Fragment, null,
            userName,
            "\u3055\u3093\u306E\u305F\u3081\u306E\u30E1\u30CB\u30E5\u30FC\u304C\u5B8C\u6210\u3057\u307E\u3057\u305F\uFF01")))));
};
const pulseAnimation = {
    '0%': {
        transform: 'scale(0.94) translateZ(0)',
    },
    '50%': {
        transform: 'scale(1.07) translateZ(0)',
    },
    '100%': {
        transform: 'scale(0.94) translateZ(0)',
    },
};
const styles = StyleSheet.create({
    container: {
        padding: '0 36px',
    },
    iconBox: {
        display: 'flex',
        justifyContent: 'center',
        height: 60,
    },
    aiIcon: {
        width: 62,
        height: 60,
        margin: '0 auto',
    },
    animation: {
        backfaceVisibility: 'hidden',
        transformOrigin: 'center center',
        willChange: 'transform',
        animationName: [pulseAnimation],
        animationDuration: '1.2s',
        animationTimingFunction: 'ease-in-out',
        animationIterationCount: 'infinite',
        animationFillMode: 'both',
        '@media (prefers-reduced-motion: reduce)': {
            animationName: 'none',
        },
    },
    loadingMessage: {
        fontSize: 20,
        fontWeight: 'bold',
        letterSpacing: '1.6px',
        textAlign: 'center',
        margin: '30px 0',
    },
});
